import { gql } from '@apollo/client';

export const UPDATE_TEMPLATE = gql`
  mutation updateTemplate($id: ID!, $data: TemplateInput!) {
    updateTemplate(id: $id, data: $data) {
      data {
        id
        attributes {
          name
          template
        }
      }
    }
  }
`;

export interface UpdateTemplateVars {
  id: string;
  data: { template: string };
}

export interface UpdateTemplateData {
  updateTemplate: {
    data: {
      id: string;
      name: string;
      template: string;
    } | null;
  } | null;
}
